const footerDesktopQuery = window.matchMedia('(min-width: 750px)');

function syncFooterGroups() {
  document.querySelectorAll('.footer__group').forEach((details) => {
    if (details.dataset.userToggled === 'true') return;
    details.open = footerDesktopQuery.matches;
  });
}

document.addEventListener('DOMContentLoaded', () => {
  syncFooterGroups();

  document.querySelectorAll('.footer__group').forEach((details) => {
    const summary = details.querySelector('summary');
    summary.addEventListener('click', (event) => {
      if (footerDesktopQuery.matches) {
        event.preventDefault();
        return;
      }
      details.dataset.userToggled = 'true';
    });
  });
});

footerDesktopQuery.addEventListener('change', syncFooterGroups);
